import { Component, OnInit, ViewChild } from '@angular/core';
import { SwalService } from '@shared/utils/swal.service';
import { Table } from 'primeng/table';
import { AbcMotivoFormComponent } from './abc-motivo-form/abc-motivo-form.component';
import Swal from 'sweetalert2';
import { MotivoService, IMotivo, IMotivoRequest } from '@p-parametria/mantenimiento/abc-motivos/services/motivo.service';

interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-abc-motivos',
  templateUrl: './abc-motivos.component.html',
  styleUrls: ['./abc-motivos.component.css']
})
export class AbcMotivosComponent implements OnInit {
  @ViewChild('dt') table: Table;
  @ViewChild(AbcMotivoFormComponent) formComponent: AbcMotivoFormComponent;

  displayDialog: boolean = false;
  selectedData: IMotivo | null = null;
  dataSource: IMotivo[] = [];
  loading: boolean = false;
  allData: number = 0;

  columns: Column[] = [
    { field: 'motivo', header: 'Código' },
    { field: 'descripcion', header: 'Descripción' },
    { field: 'tipo', header: 'Tipo Motivo' },
    { field: 'actions', header: 'Acciones' }
  ];

  constructor(
    private motivoService: MotivoService,
    private _swalService: SwalService
  ) {}

  ngOnInit(): void {
    this.read();
  }

  read() {
    this.loading = true;
    this.motivoService.GetMotivos().subscribe({
      next: (res) => {
        if (res.success) {
          this.dataSource = res.data;
          this.allData = res.data.length;
        } else {
          this._swalService.error('Error al cargar los datos');
        }
        this.loading = false;
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
        this._swalService.error('Error al cargar los datos');
      }
    });
  }

  openCreate() {
    this.selectedData = null;
    this.displayDialog = true;
    setTimeout(() => {
      if (this.formComponent) {
        this.formComponent.model = null;
        this.formComponent.modelRecived = null;
      }
    });
  }

  openUpdate(element: IMotivo) {
    this.selectedData = element;
    this.displayDialog = true;
  }

  onDialogClosed(refresh?: boolean) {
    this.displayDialog = false;
    if (refresh) {
      this.read();
    }
  }

  delete(model: IMotivo) {
    Swal.fire({
      title: '¿Está seguro?',
      text: `¿Está seguro de eliminar el motivo ${model.motivo}?`,
      icon: 'warning',
      showCancelButton: true,
      iconColor: "#d33",
      confirmButtonColor: "#d33",
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.motivoService.DeleteMotivo(model.motivo).subscribe({
          next: (res) => {
            if (res.success && res.data) {
              this._swalService.success('Motivo eliminado correctamente');
              this.read();
            } else {
              this._swalService.error('No se pudo eliminar el motivo');
            }
            this.loading = false;
          },
          error: (err) => {
            console.error('Error al eliminar motivo:', err);
            this._swalService.error('Error al eliminar el motivo');
            this.loading = false;
          }
        });
      }
    });
  }
}
